import { z } from 'zod'
import { type ERPSettings } from '../../models/ERPSettings'
import { mapDTOToStockERPSettings, mapStockERPSettingsToDTO, StockERPSettingsDTO } from './StockERPSettingsDTO'
import { mapDTOToSupplierERPSettings, mapSupplierERPSettingsToDTO, SupplierERPSettingsDTO } from './SupplierERPSettingsDTO'
import { CarrierERPSettingsDTO, mapCarrierERPSettingsToDTO, mapDTOToCarrierERPSettings } from './CarrierERPSettingsDTO'
import { IntegrationERPSettingsDTO, mapDTOToIntegrationERPSettings, mapIntegrationERPSettingsToDTO } from './IntegrationERPSettingsDTO'
import { CustomerERPSettingsDTO, mapCustomerERPSettingsToDTO, mapDTOToCustomerERPSettings } from './CustomerERPSettingsDTO'
import { mapDTOToNewsERPSettings, mapNewsERPSettingsToDTO, NewsERPSettingsDTO } from './NewsERPSettingsDTO'
import { mapDTOToUserSessionERPSettings, mapUserSessionERPSettingsToDTO, UserSessionERPSettingsDTO } from './UserSessionERPSettingsDTO'
import { mapDTOToProductCategoryERPSettings, mapProductCategoryERPSettingsToDTO, ProductCategoryERPSettingsDTO } from './ProductCategoryERPSettingsDTO'
import { ConsumptionSheetERPSettingsDTO, mapConsumptionSheetERPSettingsToDTO, mapDTOToConsumptionSheetERPSettings } from './ConsumptionSheetERPSettingsDTO'

export const ERPSettingsDTO = z.object({
  news: NewsERPSettingsDTO.optional(),
  consumption_sheet: ConsumptionSheetERPSettingsDTO.optional(),
  user_session: UserSessionERPSettingsDTO.optional(),
  product_category: ProductCategoryERPSettingsDTO.optional(),
  stock: StockERPSettingsDTO.optional(),
  customer: CustomerERPSettingsDTO.optional(),
  integration: IntegrationERPSettingsDTO.optional(),
  supplier: SupplierERPSettingsDTO.optional(),
  carrier: CarrierERPSettingsDTO.optional()
})

export type ERPSettingsDTO = z.infer<typeof ERPSettingsDTO>

export function mapERPSettingsToDTO (model: ERPSettings): ERPSettingsDTO {
  return {
    news: model.news ? mapNewsERPSettingsToDTO(model.news) : undefined,
    consumption_sheet: model.consumptionSheet ? mapConsumptionSheetERPSettingsToDTO(model.consumptionSheet) : undefined,
    user_session: model.userSession ? mapUserSessionERPSettingsToDTO(model.userSession) : undefined,
    product_category: model.productCategory ? mapProductCategoryERPSettingsToDTO(model.productCategory) : undefined,
    stock: model.stock ? mapStockERPSettingsToDTO(model.stock) : undefined,
    customer: model.customer ? mapCustomerERPSettingsToDTO(model.customer) : undefined,
    integration: model.integration ? mapIntegrationERPSettingsToDTO(model.integration) : undefined,
    supplier: model.supplier ? mapSupplierERPSettingsToDTO(model.supplier) : undefined,
    carrier: model.carrier ? mapCarrierERPSettingsToDTO(model.carrier) : undefined
  }
}

export function mapDTOToERPSettings (dto: ERPSettingsDTO): ERPSettings {
  return {
    news: dto.news ? mapDTOToNewsERPSettings(dto.news) : undefined,
    consumptionSheet: dto.consumption_sheet ? mapDTOToConsumptionSheetERPSettings(dto.consumption_sheet) : undefined,
    userSession: dto.user_session ? mapDTOToUserSessionERPSettings(dto.user_session) : undefined,
    productCategory: dto.product_category ? mapDTOToProductCategoryERPSettings(dto.product_category) : undefined,
    stock: dto.stock ? mapDTOToStockERPSettings(dto.stock) : undefined,
    customer: dto.customer ? mapDTOToCustomerERPSettings(dto.customer) : undefined,
    integration: dto.integration ? mapDTOToIntegrationERPSettings(dto.integration) : undefined,
    supplier: dto.supplier ? mapDTOToSupplierERPSettings(dto.supplier) : undefined,
    carrier: dto.carrier ? mapDTOToCarrierERPSettings(dto.carrier) : undefined
  }
}
